module.exports = __webpack_public_path__ + "img/Rotating.91c9006b.svg";